import { render, staticRenderFns } from "./LinkBase.vue?vue&type=template&id=57586f03&scoped=true&"
import script from "./LinkBase.vue?vue&type=script&lang=js&"
export * from "./LinkBase.vue?vue&type=script&lang=js&"
import style0 from "./LinkBase.vue?vue&type=style&index=0&id=57586f03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57586f03",
  null
  
)

export default component.exports